import { gql } from '@apollo/client'

export const START_WORKER_IMPERSONATION = gql`
	mutation StartWorkerImpersonation($workerId: String!, $reason: String!) {
		startWorkerImpersonation(workerId: $workerId, reason: $reason) {
			sessionId
			code
		}
	}
`

export const END_WORKER_IMPERSONATION = gql`
	mutation EndWorkerImpersonation($sessionId: String!) {
		endWorkerImpersonation(sessionId: $sessionId) {
			success
		}
	}
`

export const REGENERATE_IMPERSONATION_CODE = gql`
	mutation RegenerateImpersonationCode($sessionId: String!) {
		regenerateImpersonationCode(sessionId: $sessionId) {
			code
		}
	}
`
